// Need to use the React-specific entry point to import createApi
import type {EntityIdentifierEnum} from 'src/api/ProactApiClient';
import {lockApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export interface IGetLockListRequest {
  id: number;
  type: EntityIdentifierEnum;
}
// Define a service using a base URL and expected endpoints
export const lockApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getIsLocked: builder.query<boolean, IGetLockListRequest>({
      queryFn: clientQuery(params =>
        lockApiClient.isLocked(params.id, params.type)
      ),
      // Lock status is point-in-time data; a cached value is worse than a
      // fresh request (a stale `false` reads as an unlock event).
      keepUnusedDataFor: 0,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetIsLockedQuery} = lockApi;
